import { slick } from "@accessible360/accessible-slick";

class Related {
    constructor(element) {
        this.el = element;
        if (!this.el) return;

        this.type = this.el.dataset.carousel;

        this.init();
    }

    init() {
        const is_above_breakpoint =
            window.matchMedia("(min-width: 48em)").matches;

        if (
            this.type == "related-events-all-screens" ||
            this.type == "related-programmes" ||
            (this.type == "related-events" && is_above_breakpoint) ||
            (this.type == "related-content" && is_above_breakpoint) ||
            (this.type == "related-stories" && !is_above_breakpoint)
        ) {
            this.createCarousel();
        }
    }

    createCarousel() {
        const arrow = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22"><path fill-rule="evenodd" d="M10.6 21.3a1 1 0 0 1-1-1V3.4l-7.9 8A1 1 0 0 1 .3 9.8L9.9.3a1 1 0 0 1 1.4 0L21 9.9a1 1 0 0 1-1.5 1.4l-7.9-7.9v16.9c0 .5-.4 1-1 1Z" clip-rule="evenodd"/></svg>`;
        const props = {
            dots: false,
            arrows: true,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            adaptiveHeight: false,
            arrowsPlacement: "afterSlides",
            prevArrow:
                '<button type="button" data-control-prev><span class="sr-text">Previous</span>' +
                arrow +
                "</button>",
            nextArrow:
                '<button type="button" data-control-next><span class="sr-text">Next</span>' +
                arrow +
                "</button>",
            responsive: [
                { breakpoint: 768, settings: { slidesToShow: 1 } },
                { breakpoint: 992, settings: { slidesToShow: 2 } },
                { breakpoint: 1242, settings: { slidesToShow: 2 } },
            ],
        };

        let carousel = $(this.el).slick(props);
        this.el.carousel = carousel;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const relatedCarousels = document.querySelectorAll(
        "[data-carousel='related-events-all-screens'], [data-carousel='related-programmes'], [data-carousel='related-events'], [data-carousel='related-content'], [data-carousel='related-stories']",
    );

    relatedCarousels.forEach((element) => {
        new Related(element);
    });

    const isMobile = window.matchMedia("(max-width: 47.99em)").matches;

    if (isMobile) {
        const loadMoreContainers = document.querySelectorAll(
            "[data-load-more='true']",
        );

        loadMoreContainers.forEach((container) => {
            const btn = container.parentElement.querySelector(
                ".btn--load-more-mobile",
            );

            if (btn) {
                btn.addEventListener("click", function () {
                    const hiddenCards = container.querySelectorAll(
                        ".related__card.is-hidden-mobile"
                    );

                    // Show only the first 3 hidden cards
                    const cardsToShow = Array.from(hiddenCards).slice(0, 3);
                    cardsToShow.forEach((card) => card.classList.remove("is-hidden-mobile"));

                    // If there are no more hidden cards after this batch, remove the button
                    if (container.querySelectorAll(".related__card.is-hidden-mobile").length === 0) {
                        btn.remove();
                    }
                });
            }
        });
    }
});

export default Related;
